import { MemoizedSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { SoldTo } from '../../../../core/model/user.model';
import { PyStateUtils } from '../../../../core/state';
import { SoldToState, StateWithSoldTo } from '../sold-to-state';
import { getSoldToState } from './feature.selector';

export const getActiveSoldToLoaderState: MemoizedSelector<StateWithSoldTo, StateUtils.LoaderState<SoldTo>> = createSelector(
  getSoldToState,
  (state: SoldToState) => state.active || PyStateUtils.initialLoaderState
);

export const getActiveSoldTo: MemoizedSelector<StateWithSoldTo, SoldTo | undefined> = createSelector(
  getActiveSoldToLoaderState,
  (state: StateUtils.LoaderState<SoldTo>) => StateUtils.loaderValueSelector(state) || undefined
);

export const getActiveSoldToLoading: MemoizedSelector<StateWithSoldTo, boolean> = createSelector(
  getActiveSoldToLoaderState,
  (state: StateUtils.LoaderState<SoldTo>) => StateUtils.loaderLoadingSelector(state)
);

export const getActiveSoldToLoaded: MemoizedSelector<StateWithSoldTo, boolean> = createSelector(
  getActiveSoldToLoaderState,
  (state: StateUtils.LoaderState<SoldTo>) => StateUtils.loaderSuccessSelector(state) && !StateUtils.loaderLoadingSelector(state)
);
